import React from "react"
import { Platform } from "react-native"
import { Text } from "react-native-paper"
import { theme } from "../../theme/theme"

const TextM = (props) => {
    const {
        fontWeight,
        fontSize,
        fontStyle,
        color,
        wrap,
        capitalize,
        uppercase,
        center,
    } = props

    return (
        <Text
            {...props}
            numberOfLines={wrap ? 0 : 1}
            style={{
                flex: Platform.OS !== "web" ? 0 : null,
                color: color ?? theme.colors.grey,
                fontStyle: fontStyle ?? "normal",
                fontFamily: "Montserrat-" + (fontWeight ?? "Regular"),
                fontSize: fontSize ?? 14,
                textTransform: capitalize
                    ? "capitalize"
                    : uppercase
                    ? "uppercase"
                    : "none",
                textAlign: center ? "center" : "left",
                ...props.style,
            }}
        >
            {props.children}
        </Text>
    )
}

export default TextM
